import Vue from 'vue'
import App from './App.vue'
import store from "./store";
import "./permission";

import router from "./router";//npm install --save vue-router
import "./assets/css/common.css";//公共样式
import "./assets/iconfont/iconfont.css"//字体图标
import VueI18n from 'vue-i18n' //中英文切换npm install --save vue-i18n
Vue.config.productionTip = false


// ui样式
import ElementUI from 'element-ui';//npm i element-ui -S
import 'element-ui/lib/theme-chalk/index.css';
import ViewUI from 'view-design';//npm install view-design --save
import 'view-design/dist/styles/iview.css';

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'//npm install swiper vue-awesome-swiper --save
import 'swiper/css/swiper.css'

//vue-social-share
// npm install vue-social-share -S
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css';
import '../node_modules/social-share.js/dist/js/social-share.min.js'
 
// 富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 视频
import VueVideoPlayer from 'vue-video-player';//npm install vue-video-player --save
import 'video.js/dist/video-js.css';
// 懒加载
// import VueLazyload from "vue-lazyload";
// Vue.use(VueLazyload);

Vue.use(VueVideoPlayer);
Vue.use(Share)
Vue.use(VueQuillEditor);
Vue.use(VueAwesomeSwiper)
Vue.use(VueI18n)
Vue.use(ElementUI)
Vue.use(ViewUI)

const i18n = new VueI18n({
  locale:'zh',
  messages:{
    'zh':require('./assets/lang/zh'),
    'en':require('./assets/lang/en')
  },
  silentTranslationWarn:true,
})
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: require('@/assets/images/error.jpg'),
//   loading: require('@/assets/images/error.jpg'),
//   dispatchEvent:true,
//   attempt: 1
// })
new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
